export default __webpack_public_path__ + "static/media/3078.07e9822c.jpg";